// Serialize an object as JSON-LD safe for embedding inside a <script> tag.
// JSON.stringify alone does not escape <, > or & so a crafted string (e.g. a URL
// path in a breadcrumb) could break out of the script element. Escape them.
export function jsonLdHtml(obj) {
  return JSON.stringify(obj)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026");
}
